import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { Post } from '../post/post';
import { Like } from '../like/like';
import { CommonProvider } from '../common';

/*
  Generated class for the CommentProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CommentProvider {

  constructor(public http: HttpClient, private commonProvider: CommonProvider) {}

  private _url: string = 'api/v1/comment';
  private _postUrl: string = 'api/v1/post';

  getAllForPost(post: Post | string): Observable<Response<Comment>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.get<Response<Comment>>(this.commonProvider.apiUrl + this._postUrl + `/${id}/comment/list`);
  }

  get(id: string): Observable<Response<Comment>> {
    return this.http.get<Response<Comment>>(this.commonProvider.apiUrl + this._url + `/${id}/show`);
  }

  create(post: Post | string, comment: CommentCreate): Observable<Response<Comment>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.post<Response<Comment>>(this.commonProvider.apiUrl + this._postUrl + `/${id}/comment/create`, comment);
  }

  update(comment: Comment | string, commentUpdate: CommentUpdate): Observable<Response<Comment>> {
    const id = typeof comment == 'string' ? comment : comment.id;
    return this.http.post<Response<Comment>>(this.commonProvider.apiUrl + this._url + `/${id}/update`, commentUpdate);
  }

  delete(comment: Comment | string): Observable<Response<any>> {
    const id = typeof comment == 'string' ? comment : comment.id;
    return this.http.post<Response<any>>(this.commonProvider.apiUrl + this._url + `/${id}/delete`, null);
  }
  
  doLike(comment: Comment | string): Observable<Response<Like>> {
    const id = typeof comment == 'string' ? comment : comment.id;
    return this.http.post<Response<Like>>(this.commonProvider.apiUrl + this._url + `/${id}/like/create`, null);
  }
  
  getLikes(comment: Comment | string): Observable<Response<Like[]>> {
    const id = typeof comment == 'string' ? comment : comment.id;
    return this.http.get<Response<Like[]>>(this.commonProvider.apiUrl + this._url + `/${id}/like/list`);
  }

}

export interface Comment {
  id: string;
  company_id?: string;
  user_id: string;
  post_id: string;
  image_id?: string;
  content: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface CommentCreate {
  image: string;
  content: string;
}

export interface CommentUpdate {
  image: string;
  content: string;
}



// WEBPACK FOOTER //
// ./src/providers/comment/comment.ts